
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ElementPreset } from "@/types/presets";
import { applyPresetToActiveElementIfMatchingTypeOrCreateNewElementOfThatTypeAndThenApplyPreset } from "@/lib/presets/presets";

@Component
export default class PresetsInDesignTab extends Vue {
  @Prop({
    default: []
  })
  presets!: ElementPreset[];

  applyPreset(preset: ElementPreset) {
    applyPresetToActiveElementIfMatchingTypeOrCreateNewElementOfThatTypeAndThenApplyPreset(
      preset
    );
    this.$emit("presetApplied");
  }
}
